import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatPLN, formatDate } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import StatusBadge from "@/components/StatusBadge";
import { AlertTriangle } from "lucide-react";

export default function OrdersToApprove() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    api.get("/orders", { params: { status_filter: "do_akceptacji" } }).then((r) => setOrders(r.data));
  }, []);

  return (
    <div>
      <PageHeader testId="orders-to-approve" title="Zamówienia do akceptacji" subtitle={`${orders.length} oczekuje na decyzję`} />

      <div className="ol-card overflow-hidden">
        {orders.length === 0 ? (
          <div className="p-12 text-center text-sm text-slate-500">Brak zamówień do akceptacji.</div>
        ) : (
          <table className="ol-table" data-testid="approve-table">
            <thead>
              <tr>
                <th>Numer</th>
                <th>Budowa</th>
                <th>Pracownik</th>
                <th>Złożone</th>
                <th>Pozycje</th>
                <th className="text-right">Wartość</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o.id}>
                  <td className="font-mono text-xs">{o.order_number}</td>
                  <td className="text-slate-700">{o.site_name}</td>
                  <td className="text-slate-600">{o.created_by_name}</td>
                  <td className="text-slate-600">{formatDate(o.submitted_at)}</td>
                  <td>{o.items?.length || 0}</td>
                  <td className="text-right font-semibold">
                    {formatPLN(o.final_total_net)}
                    {o.budget_warning && (
                      <div className="inline-flex items-center gap-1 ml-2 text-xs text-amber-600" title="Przekracza budżet">
                        <AlertTriangle className="w-3.5 h-3.5" />
                      </div>
                    )}
                  </td>
                  <td><StatusBadge status={o.status} /></td>
                  <td>
                    <Link to={`/orders/${o.id}`} data-testid={`review-order-${o.order_number}`}
                      className="px-3 py-1.5 rounded-md bg-[#FF6B1A] hover:bg-[#E65A10] text-white text-xs font-semibold transition-colors">
                      Przejrzyj
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
